<template>
  <div id="_2022_5">
    <div id="Call-for-Nominations">
      <h3>
        <strong class="home-h"
          >The fourth training course on geographical analysis models in China
        </strong>
      </h3>
      <hr />
      <p>
        The 4th training course on geographic analysis models in China was
        successfully held from August 1st to 8th, 2024. It was mainly organized
        by Nanjing Normal University, the Geographical Society of China (GSC),
        China Society of Natural Resources (CSNR), China Association for
        Geospatial Information Society (CAGIS), Chinese National Committee of
        International Society for Digital Earth (ISDE). Our Modeling
        Geographical Systems Commission (MGSC) of the International Geographical
        Union (IGU) was also one of the co-organizers to support the training
        course.
      </p>
      <p>
        This training course focused on the topic “Hazards simulation and
        sustainable development”. Four models are introduced in detail,
        including the disaster remote sensing model developed by the team of
        Prof. Fang Chen (Aerospace Information Research Institute, CAS), the
        Massflow model developed by the team of Prof. Chaojun Ouyang (Institute
        of Mountain Hazards and Environment, CAS), the earthquake landslide
        model developed by the team of Prof. Chong Xu (National Institute of
        Natural Hazards), and the HazardCM model developed by the teams of Prof.
        Qiang Dai (Nanjing Normal University). There were 1062 students from 342
        universities, institutes, and companies in 10 countries attending the
        online training course.
      </p>
      <p>
        The success of this training course can promote the construction of the
        geographic model ecosystem in China and the open and sustainable
        geographic model community. It can also facilitate model reusing,
        knowledge sharing, and collaborative geographic research.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: '_2024_3'
};
</script>
<style scoped lang="less">
#_2022_5 {
  height: fit-content;
  font-size: 1.2rem;
  line-height: 2rem;
  width: 65%;
  margin: 0 auto;
  position: relative;
  word-spacing: 0.3rem;
  margin-top: 2.2rem;
  line-height: 2rem;
  text-align: justify;
  height: 50rem;
}

h3 {
  color: #1a80b6;
  font-size: 1.3rem;
  font-weight: 1000;
}

h4 {
  margin-top: 0.9rem;
  margin-bottom: 0.9rem;
}

.home-date {
  font-weight: bold;
  color: grey;
}

a {
  text-decoration: none;
}

.pic {
  // display: table-cell;
  text-align: center;
  height: 128px;
  width: 128px;
  overflow: hidden;
}
.flex {
  display: flex;
  // justify-content: center;
}
</style>
